// @ts-nocheck
import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[lbcaFileUpload]',
})
export class FileUploadDirective {
	@HostBinding('class.fileover') fileOver: boolean = false;
	@HostBinding('class.loading') fileUploading: boolean = false;

	@Output() fileDropped = new EventEmitter<any>();

	constructor() {}

	@HostListener('dragover', ['$event']) onDragOver(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		this.fileOver = true;
		this.fileUploading = false;
	}

	@HostListener('dragleave', ['$event']) public onDragLeave(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		this.fileOver = false;
	}

	@HostListener('drop', ['$event']) public onDrop(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		this.fileOver = false;
		const files = evt.dataTransfer.files;
		if (files.length > 0) {
			this.fileDropped.emit(files);
			this.fileUploading = true;
		}
	}
}
